
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestfloorcleaningmachines/terms-and-conditions",
      function () {
        return require("private-next-pages/bestfloorcleaningmachines/terms-and-conditions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestfloorcleaningmachines/terms-and-conditions"])
      });
    }
  